

<template>
  
  <v-app id="searchBtodNew">
    <v-main>
     <v-container fluid>
       <v-row no-gutters>
        <v-card class="px-2">

      
          <v-btn v-if="items.length > 0" class="primary mx-2" x-small @click="exportBtod()">Export order to ABN-AMRO</v-btn>
          <v-btn class="primary mx-2" x-small @click="searchHoct()">Search hosts to pay</v-btn>
          <v-btn v-if="items.length > 0" text icon  @click="removeBtodAll()"><v-icon small>mdi-trash-can-outline</v-icon></v-btn>

            <v-text-field
            v-model="search"
              label="Search"
              single-line
              hide-details
             >
            </v-text-field>
        
            <v-data-table 
            :items="items" 
            :items-per-page="50" 
            :footer-props="{'items-per-page-options': [50, 100, 200, 300, 500]}"
            :headers="headers"
            :search="search"        
            >
            <template v-slot:item="props">
              <tr>
              <td>{{props.item.btod_aan_type}} </td>
              <td>{{props.item.btod_aan_oms}} </td>
              <td>{{props.item.btod_ref_type}} </td>         
              <!--
              <td @click="$router.open('/huov/onHuov/' + props.item.huov_encrid)"><a> {{props.item.btod_ref_oms}} </a></td>
              -->
              <td @click="openDetail(props.item)"><a> {{props.item.btod_ref_oms}} </a></td>
              <td>{{props.item.btod_ref_oms2}} </td>
              <td align="right">{{props.item.btod_bedrag}} </td>
              <td><v-btn text icon  @click="removeBtod(props.item.btod_tabel,props.item.btod_encrid)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn></td>
              
              </tr>
            </template>
            </v-data-table>
        </v-card>
        </v-row>
     </v-container>
    <!-- <exportBtod ref="exportBtod"></exportBtod> -->
    <addHcbo ref="addHcbo" @setAmount="setAmount" @searchBtod="searchBtod"></addHcbo>
    <rmBtod ref="rmBtod"></rmBtod>
    <rmBtodAll ref="rmBtodAll"></rmBtodAll>
    </v-main>
    <navBar :title="'Ares - Finance'" :home="true" type="finance"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
// import exportBtod from "@/views/task/fin/abn/exportBtod.vue";
import addHcbo from "@/views/task/fin/abn/addHcbo.vue";
import rmBtod from "@/views/task/fin/abn/rmBtod.vue";
import rmBtodAll from "@/views/task/fin/abn/rmBtodAll.vue";

    export default {
        components: {
            navBar,
            // exportBtod,
            addHcbo,
            rmBtod,
            rmBtodAll
        },
        data() {
            return {
                maxAmount: 1000000,
                items: [],
                search: '',
                headers: [
                    {text: 'Type', value: 'btod_aan_type'},
                    {text: 'Description', value: 'btod_aan_oms'},
                    {text: 'Ref. Type', value: 'btod_ref_type'},
                    {text: 'Ref. Description', value: 'btod_ref_oms'},
                    {text: 'Ref. Description detail', value: 'btod_ref_oms2'},
                    {text: 'Amount', align: 'end', value: 'btod_bedrag'}
                ]
            }
        },
        mounted() {
            this.searchBtod();
            this.getMaxAmountHcbo();
        },
        methods: {
            searchBtod() {
                this.$axios.post("ares/json/ares/task/fin/abn/searchBtod.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "searchBtod"
                    },
                    searchBtod: {
                        stat: 'new'
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.items = res.data.searchBtod;
                    }
                });
            },
            setAmount(amount) {
                this.maxAmount = amount;
            },
            exportBtod() {
                this.$axios.post("ares/json/ares/task/fin/abn/exportBtod.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "exportBtod"
                    },
                    exportBtod: {
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.searchBtod();
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.exportBtod.text,
                            color: res.data.exportBtod.color
                        });
                       this.searchBtod();
                    }
                });
            },
            // exportBtod2() {
            //     this.$refs.exportBtod.open();
            // },
            searchHoct() {
                this.$refs.addHcbo.openDialog(this.maxAmount);
            },
            removeBtod(btod_tabel,btod_encrid) {
                this.$refs.rmBtod.open(btod_tabel,btod_encrid);
            },
            removeBtodAll() {
                this.$refs.rmBtodAll.open();
            },
            openDetail(item) {
                console.log(item.btod_aan_type);
                try {
                    if (item.btod_ref_type =='Credits'){
                        this.$router.open('/klnt/onKlnt/' + item.klnt_encrid);
                    } else {
                        this.$router.open('/huov/onHuov/' + item.huov_encrid);
                    }
                } catch(err){
                    console.log(err.message);
                }
            },
            getMaxAmountHcbo() {
                this.$axios.post("ares/json/ares/task/fin/abn/getMaxAmountHcbo.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getMaxAmountHcbo"
                    },
                    getMaxAmountHcbo: {
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.maxAmount = res.data.getMaxAmountHcbo;
                    }
                });
            },
        }  
    }

</script> 
